import moment from "moment";
import { Branch } from "../components/app/app";

export function formatLatestDate(eventDate: string) {
  if (eventDate === undefined || eventDate === "") {
    return "No data received within date range specified";
  }

  return moment(eventDate).format("ddd D MMM YYYY, HH:mm");
}

export function getLastUpdated() {
  return moment().format("HH:mm DD/MM/YY");
}

export function getBranchHeader(branchData: Branch[], branchId: string) {
  const branch = branchData.find((x) => x.branchId === parseInt(branchId));
  if (branch === undefined) return "";
  return branch.branchName;
}
